import { IMapForecastScreen } from "campaign/model"
import { Feature, Polygon } from "geojson"
import { ILocation, IPoint } from "geometry/model"
import { geometrySVC } from "geometry/service"
import { Map } from "mapbox-gl"
import { MAP_COLOR } from "ui/model"
import { IMPRESSIONS_SOURCE_ID, IMPRESSION_LAYER_ID, INVENTORY_PITCH } from "../model"
import { state } from "../state"
import { refreshInventoryMapData } from "./inventory"

export function activateInventoryImpressionsView(noRefresh?: boolean): void {
  const { map } = state.inventory
  if (!map) {
    return
  }
  if (!noRefresh) {
    refreshInventoryMapData()
  }
  setImpressionLayersVisibility(true)
  if (!state.inventory.isMapOpening) {
    map.flyTo({ pitch: INVENTORY_PITCH })
  }
}

export function deactivateInventoryImpressionsView(): void {
  const { map } = state.inventory
  if (!map) {
    return
  }
  setImpressionLayersVisibility(false)
  map.flyTo({ pitch: 0 })
}

export function getAllImpressionLayerIds(): string[] {
  return [IMPRESSION_LAYER_ID]
}

export function getClickableInventoryImpressionsLayerIds(): string[] {
  return []
}

export function createInventoryMapImpressionsLayers(map: Map): void {
  map.addLayer({
    id: IMPRESSION_LAYER_ID,
    type: "fill-extrusion",
    source: IMPRESSIONS_SOURCE_ID,
    paint: {
      "fill-extrusion-color": MAP_COLOR,
      "fill-extrusion-height": state.inventory.screensStyleExtrusion,
      "fill-extrusion-base": 0,
      "fill-extrusion-opacity": 0.8
    }
  })
}

export function setImpressionLayerStyleForData(maxImpressions: number, resolutionMetersPerPixel: number) {
  const { map } = state.inventory
  if (!map || !map.getLayer(IMPRESSION_LAYER_ID)) {
    return
  }
  const extrusion = [
    "interpolate",
    ["linear"],
    ["get", "impressions"],
    0, // impression == 0
    maxImpressions > 0 ? 10 * resolutionMetersPerPixel : 0, // 10px min height (if maxImpression is higher than 0)
    maxImpressions || 1, // impression == max
    200 * resolutionMetersPerPixel // 200px max height
  ]
  map.setPaintProperty(IMPRESSION_LAYER_ID, "fill-extrusion-height", extrusion)
  state.inventory.screensStyleExtrusion = extrusion
}

export const getSquareFeature = (
  center: ILocation,
  radius: number,
  forecastScreen: IMapForecastScreen
): Feature<Polygon, IMapForecastScreen> => {
  const cross = Math.sqrt(2 * radius ** 2)
  const coordinates: IPoint[] = []
  for (let i = 0; i < 4; i++) {
    coordinates.push(geometrySVC.getDestination(center, cross, (i * -360) / 4 + 45).geometry.coordinates as IPoint)
  }
  coordinates.push(coordinates[0])
  return geometrySVC.getPolygonFeature(coordinates, forecastScreen) as Feature<Polygon, IMapForecastScreen>
}

function setImpressionLayersVisibility(isVisible: boolean): void {
  const { map } = state.inventory
  if (!map) {
    return
  }
  const layerIds = getAllImpressionLayerIds()
  const visibility = isVisible ? "visible" : "none"
  for (const layerId of layerIds) {
    if (!map.getLayer(layerId)) {
      continue
    }
    if (map.getLayoutProperty(layerId, "visibility") !== visibility) {
      map.setLayoutProperty(layerId, "visibility", visibility)
    }
  }
}
